import React, { useState } from "react";
// import "./RegisterHeader.css";
import "../Css/RegisterHeader.css";
import { Link } from "react-router-dom";
import logs from "../images/ref.png";


function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  return (
    <div className="header">
    
      <div className="header_left">
        <Link to="/">
          <img src={logs} alt="worldcom" className="header_logo" />
        </Link>
      </div>
    </div>
  );
}

export default Register;
